import {
  ExtendedTemplateItemOptions,
  FilenameTemplateItem,
} from './FilenameTemplateItem'

type Project = {
  projectName: string | null
  clientProjectNumber: string | null
  clientProjectName: string | null
}
export class ProjectFilenameTemplateItem<
  Property extends keyof Project,
  ID extends Lowercase<string>
> extends FilenameTemplateItem<Project, 'Project', Property, ID> {
  /**
   * @see {@link FilenameTemplateItem}
   */
  constructor(options: ExtendedTemplateItemOptions<Project, Property, ID>) {
    super({ classType: 'Project', ...options })
  }
}
